import expandPathTillNode from './expandPathTillNode';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';

export default action('toggleMoveToFolderPane')(function () {
    const store = getStore();
    const { folders } = getMailStore();
    store.showMoveToFolderPane = !store.showMoveToFolderPane;

    // Expand all the nodes in the path from root to folder
    // only while opening.
    if (store.showMoveToFolderPane) {
        expandPathTillNode(folders.rootFolder.FolderId.Id, folders.selectedFolderId);
    }
});
